import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames/bind'

import ReferralHeader from './Header'
import ReferralContent from './Content'

const Referral = (props = {}) => {
  return (
    <div className={cx('referral-page')}>
      <div className={cx('referral-container')}>
        <div className={cx('referral-content')}>
          {/* Header */}
          <ReferralHeader />

          {/* Content */}
          <ReferralContent />
        </div>
      </div>
    </div>
  )
}

//map state
const mapStateToProps = (state, ownProps) => ({ rdx: state })

//map dispatch
const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: bindActionCreators({}, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(Referral)
